export const SET_SAME = "SET_SAME";